import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class PropertyBelonging extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'propertyBelonging'}
            title={'PROCEDURE P10.0 PROPERTY BELONGING TO CUSTOMERS OR EXTERNAL PROVIDERS'}
            exportTitle={'<h2>Procedure P10.0 Property Belonging to Customers or External Providers</h2>'}
            exportFileName={'property_belonging.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (PropertyBelonging);
